import axios from "axios";
import { addToQueue } from "../utils/offlineQueue";

const BASE_URL = "https://stocksense-backend-g1kp.onrender.com";

const API = axios.create({
  baseURL: BASE_URL,
  timeout: 15000,
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

API.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config;
    const isOffline = !navigator.onLine;
    const isNetworkError = !error.response;
    const method = (config?.method || "get").toLowerCase();

    // Offline write — queue it
    if ((isOffline || isNetworkError) && method !== "get") {
      try {
        let data = {};
        try {
          data = JSON.parse(config.data || "{}");
        } catch {
          data = {};
        }

        await addToQueue({
          method: method.toUpperCase(),
          url: config.url,
          data,
        });

        return Promise.resolve({
          data: { offline: true, queued: true },
          status: 200,
        });
      } catch (queueError) {
        return Promise.reject(error);
      }
    }

    // Offline GET — return null silently so pages use cache
    if ((isOffline || isNetworkError) && method === "get") {
      return Promise.resolve({ data: null, offline: true });
    }

    // 401 — log out
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export default API;